define([
	'internal_util/Util',
	'internal_util/LocalizationUtil',
	'lib/jquery'
], function (
	Util,
	LocalizationUtil,
	jQuery
) {
	'use strict';

	var _identityTransformationXSL =
			'<?xml version="1.0"?>' +
			'<xsl:stylesheet version="1.0" xmlns:xsl="http://www.w3.org/1999/XSL/Transform">' +
				'<xsl:output omit-xml-declaration="yes" indent="yes" />' +
				'<xsl:template match="node()|@*">' +
					'<xsl:copy>' +
						'<xsl:apply-templates select="node()|@*" />' +
					'</xsl:copy>' +
				'</xsl:template>' +
			'</xsl:stylesheet>';


	function find(namespace, parent, element, firstLevel) {
                if (parent.length === 0) {
                    return null;
                }
		var childNodes = parent[0].getElementsByTagNameNS(namespace, element),
			childs = new Array(),
			localized = false,
			foundLocalized = false,
			language = LocalizationUtil.getShortLocale(),
			defaultNode = null,
			lastParentNode = null,
			i;

		for (i = 0 ; i < childNodes.length; i++) {
			if (localized && childNodes[i].parentNode !== lastParentNode) {
				if (!foundLocalized && defaultNode !== null) {
					childs.push(defaultNode);
				}

				foundLocalized = false;
				defaultNode = null;
			}

			if (childNodes[i].hasAttribute('xml:lang')) {
				localized = true;

				if (childNodes[i].getAttribute('xml:lang') === language
						&& (!firstLevel || childNodes[i].parentNode === parent[0])) {
					childs.push(childNodes[i]);
					foundLocalized = true;
				} else if (childNodes[i].getAttribute('xml:lang') === LocalizationUtil.getDefaultLocale()
						&& (!firstLevel || childNodes[i].parentNode === parent[0])) {
					defaultNode = childNodes[i];
				}
			} else if (!firstLevel || childNodes[i].parentNode === parent[0]) {
				localized = false;
				childs.push(childNodes[i]);
			}

			lastParentNode = childNodes[i].parentNode;
		}

		if (localized && !foundLocalized && defaultNode !== null) {
			childs.push(defaultNode);
		}

		return jQuery(childs);
	}

	/**
	 * Get the attribute of the given name from the given element.
	 * Optionally, a namespace of the attribute may be given.
	 * 
	 * @param {Element} element the element to get the attribute from.
	 * @param {type} name attribute name
	 * @param {string|null|undefined} namespace namespace of the attribute; if not present or empty, the attribute
	 * is obtained without a namespace.
	 * @returns {string|null} attribute value or null if not present.
	 */
	function getAttribute(element, name, namespace) {
		var value;
		
		if (element.length === 0) {
			return null;
		}
		
		if (Util.isValidString(namespace)) {
			// get attribute with namespace
			value = element[0].getAttributeNS(namespace, name);
		} else {
			// get attribute without namespace
			value = element[0].getAttribute(name);
		}
		
		// normalize by setting empty to null
		return Util.isValidString(value) ? value : null;
	}

	function simpleFormat(xmlString) {
		var reg = /(>)(<)(\/*)/g,
			wsexp = / *(.*) +\n/g,
			contexp = /(<.+>)(.+\n)/g,
			formatted = '',
			indent = 0,
			lastType = 'other',
			lines,
			ln,
			single,
			closing,
			opening,
			type,
			fromTo,
			padding,
			i, j,
			transitions = {
				'single->single' : 0,
				'single->closing' : -1,
				'single->opening' : 0,
				'single->other' : 0,
				'closing->single' : 0,
				'closing->closing' : -1,
				'closing->opening' : 0,
				'closing->other' : 0,
				'opening->single' : 1,
				'opening->closing' : 0,
				'opening->opening' : 1,
				'opening->other' : 1,
				'other->single' : 0,
				'other->closing' : -1,
				'other->opening' : 0,
				'other->other' : 0
			};

		xmlString = xmlString.replace(reg, '$1\n$2$3').replace(wsexp, '$1\n').replace(contexp, '$1\n$2');

		lines = xmlString.split('\n');

		for (i = 0; i < lines.length; i++) {
			ln = lines[i];
			single = Boolean(ln.match(/<.+\/>/));
			closing = Boolean(ln.match(/<\/.+>/));
			opening = Boolean(ln.match(/<[^!].*>/));
			type = single ? 'single' : closing ? 'closing' : opening ? 'opening' : 'other';
			fromTo = lastType + '->' + type;
			padding = '';

			lastType = type;

			indent += transitions[fromTo];

			for (j = 0; j < indent; j++) {
				padding += '  ';
			}

			if (fromTo == 'opening->closing') {
				formatted = formatted.substr(0, formatted.length - 1) + ln + '\n';
			} else {
				formatted += padding + ln + '\n';
			}
		}

		return formatted;
	}

	function createDom(xmlString) {
		var xmlDOM;

		if (window.ActiveXObject || "ActiveXObject" in window) {
			xmlDOM = new ActiveXObject('MSXML2.DOMDocument.6.0');
			xmlDOM.async = false;
			xmlDOM.loadXML(xmlString);
		} else if (window.DOMParser) {
			xmlDOM = (new DOMParser()).parseFromString(xmlString, 'text/xml');
		}

		return xmlDOM;
	}

	function serializeDom(xmlDOM) {
		var xmlSerializer,
			xmlString;

		if (window.ActiveXObject || "ActiveXObject" in window) {
			xmlString = xmlDOM.xml;
		} else if (window.XMLSerializer) {
			xmlSerializer = new XMLSerializer();
			xmlString = xmlSerializer.serializeToString(xmlDOM);
		}

		return xmlString;
	}

	function xslTransform(xslString, xml) {
		var xsl,
			xslTemplate,
			xsltProcessor,
			xmlSerializer,
			xmlString;

		if (Util.isValidString(xml)) {
			xml = createDom(xml);
		}

		if (window.ActiveXObject || "ActiveXObject" in window) {
			xsl = new ActiveXObject("MSXML2.FreeThreadedDOMDocument.6.0");
			xsl.async = false;
			xsl.loadXML(xslString);

			xslTemplate = new ActiveXObject("MSXML2.XSLTemplate.6.0");
			xslTemplate.stylesheet = xsl;

			xsltProcessor = xslTemplate.createProcessor();
			xsltProcessor.input = xml;
			xsltProcessor.transform();

			xmlString = xsltProcessor.output;
		} else if (document.implementation && document.implementation.createDocument) {
			xsl = createDom(xslString);

			xsltProcessor = new XSLTProcessor();
			xmlSerializer = new XMLSerializer();

			xsltProcessor.importStylesheet(xsl);

			xmlString = xmlSerializer.serializeToString(xsltProcessor.transformToDocument(xml));
		}

		return xmlString;
	}

	function format(xmlString) {
		xmlString = xslTransform(_identityTransformationXSL, xmlString);

		if (xmlString.indexOf(xmlString.indexOf('>') + 1) !== '\n') {
			xmlString = simpleFormat(xmlString);
		}

		return xmlString;
	}

	return {
		find : find,
		getAttribute : getAttribute,
		simpleFormat : simpleFormat,
		createDom : createDom,
		serializeDom : serializeDom,
		xslTransform : xslTransform,
		format : format
	};
});


//////////////////
// WEBPACK FOOTER
// ./src/main/web/js/app/util/XMLUtil.js
// module id = 51
// module chunks = 6